import React from "react";
import { withRouter } from "react-router-dom";

class TreeChildren extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
    this.state = {
      TreeList: props.TreeList,
      componentName: props.componentName,
      pathname: props.pathname,
      treeLocation: props.treeLocation,
      activeIndex: 0,
    };
  }
  handleEvent() {
    this.state = {
      TreeList: this.props.TreeList,
      componentName: this.props.componentName,
      treeLocation: this.props.treeLocation,
      pathname: this.props.pathname,
      activeIndex: 0,
    };
  }

  handleCheck(index, e) {
    document
      .getElementById("tree-parent-id")
      .setAttribute("value", e.currentTarget.dataset.id);
    this.setState({ activeIndex: index });
    e.stopPropagation();
    this.props.history.push(
      "/" + this.state.pathname + "/" + this.state.componentName,
      {
        componentName: this.state.componentName,
        treeLocation: this.state.treeLocation,
        id: e.currentTarget.dataset.id,
        TreeList: this.state.TreeList,
        isDidUpdate: e.currentTarget.dataset.id,
      }
      //** ÇALIŞAN VERSİON */
      // {
      //   componentName: this.state.componentName,
      //   treeLocation: this.state.treeLocation,
      //   id: e.currentTarget.dataset.id,
      //   TreeList: this.state.TreeList,
      //   isDidUpdate:
      //     this.state.treeLocation == "modal"
      //       ? "modal"
      //       : e.currentTarget.dataset.id,
      // }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.TreeCountUpdate != this.props.TreeCountUpdate) {
      that.Tree(
        "", // this.props.TreeList,
        this.state.componentName,
        this.state.pathname
      );
    }
  }

  componentDidMount() {
    var tree = document.querySelectorAll(".tree");
    for (var i = 0; i < tree.length; i++) {
      tree[i].addEventListener("click", function (e) {
        var text = e.target.innerText;

        var elementDiv = e.target.classList;

        var element = e.target.parentElement;
        var parent = element.parentElement;
        var opensubs = parent.querySelectorAll(":scope .open.act");
        var classList = element.classList;

        if (opensubs.length !== 0) {
          for (var i = 0; i < opensubs.length; i++) {
            opensubs[i].classList.remove("open");
            opensubs[i].classList.remove("act");
          }
        }
        classList.add("open");
        classList.add("act");

        elementDiv.add("open");
        elementDiv.add("act");
      });
    }
  }

  Tree = (data) => {
    return (
      <ul className="tree">
        {data &&
          data.map((item) => (
            <li
              key={item.id.toString()}
              data-id={item.id}
              onClick={this.handleCheck.bind(this, item.id)}
            >
              <div
                className={
                  item.children && item.children.length > 0 ? "has-child" : ""
                }
              >
                {item.name}{" "}
              </div>
              {item.children && item.children.length > 0
                ? this.Tree(item.children)
                : ""}
            </li>
          ))}
      </ul>
    );
  };

  render() {
    this.handleEvent();
    return (
      <div>
        {this.Tree(
          this.state.TreeList,
          this.state.componentName,
          this.state.pathname,
          this.state.treeLocation
        )}
      </div>
    );
  }
}

export default withRouter(TreeChildren);
